module.exports = __webpack_public_path__ + "static/media/红包_2.19bc20b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_170/img/红包_2.png
// module id = 1510
// module chunks = 0